import Immutable from "immutable";
import moment from "moment";

const LOAD = "schedule/LOAD";
const LOAD_SUCCESS = "schedule/LOAD_SUCCESS";
const LOAD_FAIL = "schedule/LOAD_FAIL";

const LOAD_PRACTICE = "schedule/LOAD_PRACTICE";
const LOAD_SUCCESS_PRACTICE = "schedule/LOAD_SUCCESS_PRACTICE";
const LOAD_FAIL_PRACTICE = "schedule/LOAD_FAIL_PRACTICE";

const LOAD_YEAR = "schedule/LOAD_YEAR";
const LOAD_YEAR_SUCCESS = "schedule/LOAD_YEAR_SUCCESS";
const LOAD_YEAR_FAIL = "schedule/LOAD_YEAR_FAIL";

const LOAD_YEAR_SHIFT = "schedule/LOAD_YEAR_SHIFT";
const LOAD_YEAR_SHIFT_SUCCESS = "schedule/LOAD_YEAR_SHIFT_SUCCESS";
const LOAD_YEAR_SHIFT_FAIL = "schedule/LOAD_YEAR_SHIFT_FAIL";

const LOAD_DAYS_YEAR = "schedule/LOAD_DAYS_YEAR";
const LOAD_DAYS_YEAR_SUCCESS = "schedule/LOAD_DAYS_YEAR_SUCCESS";
const LOAD_DAYS_YEAR_FAIL = "schedule/LOAD_DAYS_YEAR_FAIL";

const LOAD_ODDAYS_YEAR = "schedule/LOAD_ODDAYS_YEAR";
const LOAD_ODDAYS_YEAR_SUCCESS = "schedule/LOAD_ODDAYS_YEAR_SUCCESS";
const LOAD_ODDAYS_YEAR_FAIL = "schedule/LOAD_ODDAYS_YEAR_FAIL";

const LOAD_TIMEOFF_YEAR = "schedule/LOAD_TIMEOFF_YEAR";
const LOAD_TIMEOFF_YEAR_SUCCESS = "schedule/LOAD_TIMEOFF_YEAR_SUCCESS";
const LOAD_TIMEOFF_YEAR_FAIL = "schedule/LOAD_TIMEOFF_YEAR_FAIL";

const SUBMIT_CHANGE_REQUEST = "schedule/SUBMIT_CHANGE_REQUEST";
const SUBMIT_CHANGE_REQUEST_SUCCESS = "schedule/SUBMIT_CHANGE_REQUEST_SUCCESS";
const SUBMIT_CHANGE_REQUEST_FAIL = "schedule/SUBMIT_CHANGE_REQUEST_FAIL";

const LOAD_CHANGE_REQUESTS = "schedule/LOAD_CHANGE_REQUESTS";
const LOAD_CHANGE_REQUESTS_SUCCESS = "schedule/LOAD_CHANGE_REQUESTS_SUCCESS";
const LOAD_CHANGE_REQUESTS_FAIL = "schedule/LOAD_CHANGE_REQUESTS_FAIL";

const REVIEW_CHANGE_REQUEST = "schedule/REVIEW_CHANGE_REQUEST";
const REVIEW_CHANGE_REQUEST_SUCCESS = "schedule/REVIEW_CHANGE_REQUEST_SUCCESS";
const REVIEW_CHANGE_REQUEST_FAIL = "schedule/REVIEW_CHANGE_REQUEST_FAIL";

const LOAD_DATA = "schedule/LOAD_DATA";
const LOAD_DATA_SUCCESS = "schedule/LOAD_DATA_SUCCESS";
const LOAD_DATA_FAIL = "schedule/LOAD_DATA_FAIL";

const LOAD_BCARE = "schedule/LOAD_BCARE";
const LOAD_BCARE_SUCCESS = "schedule/LOAD_BCARE_SUCCESS";
const LOAD_BCARE_FAIL = "schedule/LOAD_BCARE_FAIL";

const LOAD_DENTIST_COSTS = "schedule/LOAD_DENTIST_COSTS";
const LOAD_DENTIST_COSTS_SUCCESS = "schedule/LOAD_DENTIST_COSTS_SUCCESS";
const LOAD_DENTIST_COSTS_FAIL = "schedule/LOAD_DENTIST_COSTS_FAIL";

const LOAD_PRACTICE_OFFSETS = "schedule/LOAD_PRACTICE_OFFSETS";
const LOAD_PRACTICE_OFFSETS_SUCCESS = "schedule/LOAD_PRACTICE_OFFSETS_SUCCESS";
const LOAD_PRACTICE_OFFSETS_FAIL = "schedule/LOAD_PRACTICE_OFFSETS_FAIL";

const LOAD_ALL_PRACTICE_OFFSETS = "schedule/LOAD_ALL_PRACTICE_OFFSETS";
const LOAD_ALL_PRACTICE_OFFSETS_SUCCESS =
  "schedule/LOAD_ALL_PRACTICE_OFFSETS_SUCCESS";
const LOAD_ALL_PRACTICE_OFFSETS_FAIL =
  "schedule/LOAD_ALL_PRACTICE_OFFSETS_FAIL";
const SAVE_PARAMS = "pay/SAVE_PARAMS";

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  loading: false,
  schedule: null,
  params: {
    startDate: moment().format("YYYY-MM-01"),
    endDate: moment().endOf("month").format("YYYY-MM-DD"),
    colorSelected: 0,
    practiceSelected: [],
    practiceSelectedId: [],
    typeSelected: false,
  },
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("schedule", action.res);

    case LOAD_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("schedule", null);

    case LOAD_YEAR:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_YEAR_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("scheduleYear", action.res);

    case LOAD_YEAR_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("schedule", null);

    case LOAD_YEAR_SHIFT:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_YEAR_SHIFT_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("scheduleYearShifts", action.res);

    case LOAD_YEAR_SHIFT_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("scheduleYearShifts", null);

    case LOAD_ODDAYS_YEAR:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_ODDAYS_YEAR_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("scheduleOdDays", action.res);

    case LOAD_ODDAYS_YEAR_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("scheduleOdDays", null);

    case LOAD_DAYS_YEAR:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_DAYS_YEAR_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("scheduleDays", action.res);

    case LOAD_DAYS_YEAR_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("scheduleDays", null);

    case LOAD_PRACTICE:
      return state.set("isLoad", false).set("loadErr", null);

    case LOAD_SUCCESS_PRACTICE:
      return state.set("isLoad", false).set("loadErr", null);

    case LOAD_FAIL_PRACTICE:
      return state.set("isLoad", false).set("loadErr", action.error);

    case LOAD_DATA:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_DATA_FAIL:
      return state.set("isLoad", false).set("loadErr", action.error);

    case LOAD_DATA_SUCCESS:
      return state.set("isLoad", false).set("loadErr", action.error);

    case LOAD_TIMEOFF_YEAR:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_TIMEOFF_YEAR_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("scheduleTimeOff", action.res);

    case LOAD_TIMEOFF_YEAR_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("scheduleTimeOff", null);

    case LOAD_CHANGE_REQUESTS:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_CHANGE_REQUESTS_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("changeRequests", action.res && action.res.rows ? action.res.rows : action.res)
        .set("changeRequestsCount", action.res && typeof action.res.count === "number" ? action.res.count : 0);

    case LOAD_CHANGE_REQUESTS_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("changeRequests", null)
        .set("changeRequestsCount", 0);

    case SUBMIT_CHANGE_REQUEST:
    case REVIEW_CHANGE_REQUEST:
      return state.set("isLoad", true).set("loadErr", null);

    case SUBMIT_CHANGE_REQUEST_SUCCESS:
    case REVIEW_CHANGE_REQUEST_SUCCESS:
      return state.set("isLoad", false).set("loadErr", null);

    case SUBMIT_CHANGE_REQUEST_FAIL:
    case REVIEW_CHANGE_REQUEST_FAIL:
      return state.set("isLoad", false).set("loadErr", action.error);

    case LOAD_PRACTICE_OFFSETS:
      return state.set("isLoad", false).set("loadErr", null);

    case LOAD_PRACTICE_OFFSETS_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("practiceOffsets", action.res);

    case LOAD_PRACTICE_OFFSETS_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("practiceOffsets", null);

    case LOAD_TIMEOFF_YEAR_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("scheduleTimeOff", null);

    case LOAD_ALL_PRACTICE_OFFSETS:
      return state.set("isLoad", false).set("loadErr", null);

    case LOAD_ALL_PRACTICE_OFFSETS_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("allPracticeOffsets", action.res);

    case LOAD_ALL_PRACTICE_OFFSETS_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("allPracticeOffsets", null);

    case LOAD_BCARE:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_BCARE_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("bcare", action.res);

    case LOAD_BCARE_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("bcare", null);

    case LOAD_DENTIST_COSTS:
      return state.set("isLoad", true).set("loadErr", null);

    case LOAD_DENTIST_COSTS_SUCCESS:
      return state
        .set("isLoad", false)
        .set("loadErr", null)
        .set("dentistCosts", action.res);

    case LOAD_DENTIST_COSTS_FAIL:
      return state
        .set("isLoad", false)
        .set("loadErr", action.error)
        .set("dentistCosts", null);

    case SAVE_PARAMS:
      return state.set("params", action.params);

    default:
      return state;
  }
}

export const getScheduleData =
  (userId, params = "") =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD });
    if (params) {
      dispatch({ type: SAVE_PARAMS, params: params });
      params = "/" + JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getSchedules/${userId}${params}`);
      // Resolve dentist name + mobile from the scheduleDoctors map in redux.
      // The backend no longer fetches all doctors just to merge these (it was
      // the slowest query on this endpoint). Mirrors the old server logic.
      const user = getState().get("auth").get("user");
      const drs = (user && user.scheduleDoctors) || {};
      if (Array.isArray(res)) {
        res.forEach((item) => {
          if (!item || !item.userId) return;
          const ids = String(item.userId).split(";").filter(Boolean);
          // schedules.userName is a snapshot taken when the shift was saved, so it
          // goes stale when a provider is renamed. Rebuild it from the current
          // doctor record, keeping the stored name for ids we can't resolve.
          const storedNames = String(item.desc || "").split(";");
          const names = [];
          const mobiles = [];
          ids.forEach((doctorId, i) => {
            const dr = drs[" " + doctorId.trim()];
            if (dr) {
              mobiles.push(dr.docMobile != null ? dr.docMobile : "N/A");
              item.dentist = `${dr.firstName} ${dr.lastName}`;
              names.push(`${dr.firstName} ${dr.lastName}`.trim());
            } else {
              names.push((storedNames[i] || doctorId).trim());
            }
          });
          if (item.type === "practice") item.desc = names.join(";") + ";";
          item.mobile = mobiles.length ? mobiles.join(";") : "";
        });
      }
      dispatch({ type: LOAD_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
    }
  };

export const getPracticesList =
  (doctorId, includeVirtualPractices = 0) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_PRACTICE });

    try {
      let res = await api.get(`/scheduler/getPractices?doctorId=` + doctorId+ '&virtual='+includeVirtualPractices);
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL_PRACTICE, error: err.message });
    }
  };

export const getColorsList = () => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_PRACTICE });

  try {
    let res = await api.get(`/scheduler/getColors`);
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL_PRACTICE, error: err.message });
  }
};

export const getScheduleDataByDentists =
  (params = "") =>
  async (dispatch, getState, api) => {
    if (params) {
      params = JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getSchedulesByDentists/${params}`);
      dispatch({ type: LOAD_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
    }
  };

export const publishSchedule =
  (reportObj) => async (dispatch, getState, api) => {
    try {
      let res = await api.post("/scheduler/publishSchedules", {
        data: reportObj,
      });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
    }
  };

export const getScheduleById =
  (id, isDelete) => async (dispatch, getState, api) => {
    try {
      let res = await api.get(
        "/scheduler/getScheduleById/" + id + "/" + (isDelete === true ? 1 : 0),
      );
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
    }
  };

export const publishBanner = (reportObj) => async (dispatch, getState, api) => {
  try {
    let res = await api.post("/scheduler/publishBanners", { data: reportObj });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const publishNotes = (data) => async (dispatch, getState, api) => {
  try {
    if(data && data.receipts){
        data.receipts = JSON.stringify(data.receipts);
    }
    return await api.post("/scheduler/publishNotes", { data });
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    throw err;
  }
};

export const getNotesById = (id) => async (dispatch, getState, api) => {
  try {
    let res = await api.get("/scheduler/getNotesById/" + id);
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const deleteSchedule =
  (data, isDelete) => async (dispatch, getState, api) => {
    try {
      let res = await api.put(
        "/scheduler/delete/" + (isDelete === true ? 1 : 0),
        { data },
      );
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL, error: err.message });
    }
  };

export const updateParams =
  (month, year) => async (dispatch, getState, api) => {
    const params = getState().get("schedule").get("params");
    if (month !== "undo" || year !== "undo") {
      params.startDate = moment(`${year}-${month}`, "YYYY-MM").format(
        "YYYY-MM-01",
      );
      params.endDate = moment(`${year}-${month}`, "YYYY-MM")
        .endOf("month")
        .format("YYYY-MM-DD");
    }

    dispatch({ type: SAVE_PARAMS, params: params });
  };

export const getDoctors =
  (location, type) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_PRACTICE });
    try {
      let res = await api.get(`/scheduler/getDoctors/` + location + `/` + type);
      dispatch({ type: LOAD_SUCCESS_PRACTICE, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL_PRACTICE, error: err.message });
    }
  };

export const createSchedule = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_PRACTICE });
  try {
    let res = await api.post("/scheduler/createSchedule", { data });
    dispatch({ type: LOAD_SUCCESS_PRACTICE, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL_PRACTICE, error: err.message });
    return { error: err.message || "Failed to create schedule." };
  }
};

export const updateSchedule = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_PRACTICE });
  try {
    let res = await api.put("/scheduler/edit", { data });
    dispatch({ type: LOAD_SUCCESS_PRACTICE, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL_PRACTICE, error: err.message });
  }
};

export const deleteNotes = (data) => async (dispatch, getState, api) => {
  try {
    let res = await api.put("/scheduler/deleteNotes", { data });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
  }
};

export const getSchedulesYearly =
  (params = "") =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD_YEAR });
    if (params) {
      params = "/" + JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getSchedulesYearly${params}`);
      dispatch({ type: LOAD_YEAR_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_YEAR_FAIL, error: err.message });
    }
  };

export const getAvailableShiftsYearly =
  (params = "") =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD_YEAR_SHIFT });
    if (params) {
      params = "/" + JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getAvailableShiftsYearly${params}`);
      dispatch({ type: LOAD_YEAR_SHIFT_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_YEAR_SHIFT_FAIL, error: err.message });
    }
  };

export const getTimeOffRequestsYearly =
  (params = "") =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD_TIMEOFF_YEAR });
    if (params) {
      params = "/" + JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getTimeOffRequestsYearly${params}`);
      dispatch({ type: LOAD_TIMEOFF_YEAR_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_TIMEOFF_YEAR_FAIL, error: err.message });
    }
  };
export const getPracticeOffSets =
  (practiceName) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_PRACTICE_OFFSETS });
    try {
      let res = await api.get(`/scheduler/getPracticeOffsets/` + practiceName);
      dispatch({ type: LOAD_PRACTICE_OFFSETS_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_PRACTICE_OFFSETS_FAIL, error: err.message });
    }
  };
export const getAllPracticeOffSets =
  (isActive) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_ALL_PRACTICE_OFFSETS });
    try {
      let res = await api.get(`/scheduler/getAllPracticeOffsets/` + isActive);
      dispatch({ type: LOAD_ALL_PRACTICE_OFFSETS_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_ALL_PRACTICE_OFFSETS_FAIL, error: err.message });
    }
  };

export const getOdOpenDays =
  (params = "") =>
  async (dispatch, getState, api) => {
    if (params) {
      params = "/" + JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getOdOpenDays${params}`);
      dispatch({ type: LOAD_ODDAYS_YEAR_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_ODDAYS_YEAR_FAIL, error: err.message });
    }
  };

export const getOpenDaysYearly =
  (params = "") =>
  async (dispatch, getState, api) => {
    if (params) {
      params = "/" + JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getOpenDaysYearly${params}`);
      dispatch({ type: LOAD_DAYS_YEAR_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DAYS_YEAR_FAIL, error: err.message });
    }
  };

export const getAlreadyScheduledDoctorsList =
  (selectedDate, eventId = 0) =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD_PRACTICE });
    try {
      let res = await api.get(
        `/scheduler/getAlreadyScheduledDoctors/` + selectedDate + `/` + eventId,
      );
      dispatch({ type: LOAD_SUCCESS_PRACTICE, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_FAIL_PRACTICE, error: err.message });
    }
  };

export const scheduleUpdateNotification =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.post("/scheduler/sendEmailNotification", { data });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };

export const scheduleAddEventNotification =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.post("/scheduler/scheduleAddEventNotification", {
        data,
      });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };

export const scheduleDeleteNotification =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.post("/scheduler/scheduleDeleteNotification", {
        data,
      });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };
export const getTimeOffDays =
  (params = "") =>
  async (dispatch, getState, api) => {
    dispatch({ type: LOAD_TIMEOFF_YEAR });
    if (params) {
      params = "/" + JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getTimeOffRequests${params}`);
      dispatch({ type: LOAD_TIMEOFF_YEAR_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_TIMEOFF_YEAR_FAIL, error: err.message });
    }
  };

export const getBcareData =
  (params = "") =>
  async (dispatch, getState, api) => {
    if (params) {
      params = "/" + JSON.stringify(params);
    }
    try {
      let res = await api.get(`/scheduler/getBcareYearly${params}`);
      dispatch({ type: LOAD_BCARE_SUCCESS, res: res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_BCARE_FAIL, error: err.message });
    }
  };

export const sendEmailData = (data) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_DATA });
  try {
    let res = await api.post("/scheduler/sendEmailPdf", { data });
    dispatch({ type: LOAD_DATA_SUCCESS });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_DATA_FAIL, error: err.message });
  }
};

export const getRegionList = () => async (dispatch, getState, api) => {
  try {
    let res = await api.get(`/practice/getRegionList`);
    return res;
  } catch (err) {
    console.log("error found on get practice list.", err);
    return err;
  }
};

export const updateSubstituteCosts =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.post("/substituteCost/update", { data });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };
export const updateScheduleNotes =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.post("/notes/update", { data });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };

export const toggleScheduleNote =
  (noteId) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.put(`/notes/toggle/${noteId}`);
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };

export const updateDefaultSubCosts =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.post("/substituteCost/default", { data });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };

export const getDentistCosts = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD_DENTIST_COSTS });
  if (params) {
    params = "/" + JSON.stringify(params);
  }
  try {
    let res = await api.get(`/substituteCost/get${params}`);
    dispatch({ type: LOAD_DENTIST_COSTS_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_DENTIST_COSTS_FAIL, error: err.message });
  }
};

export const deleteScheduleNote =
  (noteId) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.put(`/notes/toggle/${noteId}`);
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };

export const restoreScheduleNote =
  (noteId) => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_DATA });
    try {
      let res = await api.put(`/notes/restore/${noteId}`);
      return res;
    } catch (err) {
      dispatch({ type: LOAD_DATA_FAIL, error: err.message });
    }
  };

export const submitChangeRequest =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: SUBMIT_CHANGE_REQUEST });
    try {
      let res = await api.post("/scheduler/scheduleChangeRequest", { data });
      dispatch({ type: SUBMIT_CHANGE_REQUEST_SUCCESS });
      return res;
    } catch (err) {
      dispatch({ type: SUBMIT_CHANGE_REQUEST_FAIL, error: err.message });
      return { error: err.message || "Failed to submit request." };
    }
  };

export const getChangeRequests =
  (params = "") => async (dispatch, getState, api) => {
    dispatch({ type: LOAD_CHANGE_REQUESTS });
    if (params) params = "/" + JSON.stringify(params);
    try {
      let res = await api.get(`/scheduler/scheduleChangeRequests${params}`);
      dispatch({ type: LOAD_CHANGE_REQUESTS_SUCCESS, res });
      return res;
    } catch (err) {
      dispatch({ type: LOAD_CHANGE_REQUESTS_FAIL, error: err.message });
    }
  };

export const approveChangeRequest =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: REVIEW_CHANGE_REQUEST });
    try {
      let res = await api.put("/scheduler/scheduleChangeRequest/approve", { data });
      dispatch({ type: REVIEW_CHANGE_REQUEST_SUCCESS });
      return res;
    } catch (err) {
      dispatch({ type: REVIEW_CHANGE_REQUEST_FAIL, error: err.message });
    }
  };

export const rejectChangeRequest =
  (data) => async (dispatch, getState, api) => {
    dispatch({ type: REVIEW_CHANGE_REQUEST });
    try {
      let res = await api.put("/scheduler/scheduleChangeRequest/reject", { data });
      dispatch({ type: REVIEW_CHANGE_REQUEST_SUCCESS });
      return res;
    } catch (err) {
      dispatch({ type: REVIEW_CHANGE_REQUEST_FAIL, error: err.message });
    }
  };
